import {
  ADD_WFH_PROFILE_FAILURE,
  ADD_WFH_PROFILE_LOADING,
  ADD_WFH_PROFILE_SUCCESS,
  DELETE_WFH_PROFILE_FAILURE,
  DELETE_WFH_PROFILE_LOADING,
  DELETE_WFH_PROFILE_SUCCESS,
  FETCH_PLANNING_FAILURE,
  FETCH_PLANNING_LOADING,
  FETCH_PLANNING_SUCCESS,
  FETCH_WFH_PROFILE_FAILURE,
  FETCH_WFH_PROFILE_LOADING,
  FETCH_WFH_PROFILE_SUCCESS,
  UPDATE_PLANNING_FAILURE,
  UPDATE_PLANNING_SUCCESS,
  UPDATE_WFH_PROFILE_FAILURE,
  UPDATE_WFH_PROFILE_LOADING,
  UPDATE_WFH_PROFILE_SUCCESS
} from '../Types/wfhProfileTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: true,
  item: {},
  planning: []
};

const wfhProfileReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_WFH_PROFILE_LOADING:
    case ADD_WFH_PROFILE_LOADING:
    case UPDATE_WFH_PROFILE_LOADING:
    case DELETE_WFH_PROFILE_LOADING:
    case FETCH_PLANNING_LOADING:
      return {
        ...state,
        loading: true
      };

    case FETCH_WFH_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'WFH profile fetched successfully',
        data: action.payload
      };
    case ADD_WFH_PROFILE_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        loading: false,
        error: null,
        success: 'WFH profile added successfully'
      };

    case UPDATE_WFH_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.map(item => (item._id === action.payload._id ? action.payload : item)),
        error: null,
        success: 'WFH profile updated successfully'
      };

    case DELETE_WFH_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: 'WFH profile removed successfully',
        data: state.data.filter(item => item._id !== action.payload)
      };

    case FETCH_WFH_PROFILE_FAILURE:
    case ADD_WFH_PROFILE_FAILURE:
    case UPDATE_WFH_PROFILE_FAILURE:
    case DELETE_WFH_PROFILE_FAILURE:
    case FETCH_PLANNING_FAILURE:
    case UPDATE_PLANNING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };

    case FETCH_PLANNING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        planning: action.payload
      };

    case UPDATE_PLANNING_SUCCESS:
      return {
        ...state,
        loading: false,
        planning: state.planning
          ? state.planning.some(item => item._id === action.payload._id)
            ? state.planning.map(item => (item._id === action.payload._id ? action.payload : item))
            : [...state.planning, action.payload]
          : [action.payload],
        error: null,
        success: 'Planning updated successfully'
      };

    default:
      return { ...state };
  }
};

export default wfhProfileReducer;
